import React, { useState } from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { Stack, Text } from '@atlaskit/primitives/compiled';

import { CategorySelector, type Category } from '@confluence/category-selector';

import { SnippetsPanelSearchBar } from './SnippetsPanelSearchBar.tsx';

const messages = defineMessages({
	snippetsCategoryAll: {
		id: 'snippets.panel.categories.all',
		defaultMessage: 'All',
		description:
			'Block Template side panel category name for filtering the list of templates to All templates',
	},
	snippetsCategoryMyTemplates: {
		id: 'snippets.panel.categories.myTemplates',
		defaultMessage: 'My Templates',
		description:
			'Block Template side panel category name for filtering the list of templates to templates created by the current user',
	},
	snippetsCategoryFavorites: {
		id: 'snippets.panel.categories.favorites',
		defaultMessage: 'Favorites',
		description:
			'Block Template side panel category name for filtering the list of templates to favorited templates',
	},
});

const SnippetCategorySelector = ({
	onSelectionChange,
}: {
	onSelectionChange: (category: Category) => void;
}) => {
	const intl = useIntl();

	const categoryAll: Category = {
		id: 'snippets.all',
		name: intl.formatMessage(messages.snippetsCategoryAll),
	};
	const categoryMyTemplates: Category = {
		id: 'snippets.my-templates',
		name: intl.formatMessage(messages.snippetsCategoryMyTemplates),
	};
	const categoryFavorites: Category = {
		id: 'snippets.favorites',
		name: intl.formatMessage(messages.snippetsCategoryFavorites),
	};

	const categories: Category[] = [categoryAll, categoryMyTemplates, categoryFavorites];

	const [selectedCategoryId, setSelectedCategoryId] = useState(categoryAll.id);

	const onCategorySelectionChange = (category: Category) => {
		setSelectedCategoryId(category.id);
		onSelectionChange(category);
	};

	return (
		<CategorySelector
			categories={categories}
			selectedCategoryIds={[selectedCategoryId]}
			onCategorySelected={onCategorySelectionChange}
		/>
	);
};

export const SnippetsListPanel = () => {
	return (
		<Stack space="space.200" grow="fill">
			<SnippetsPanelSearchBar onChange={() => {}} />
			<SnippetCategorySelector onSelectionChange={() => {}} />
			{/*eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx*/}
			<Text>Coming Soon</Text>
		</Stack>
	);
};
